import TenantComponents from '../../../tenant/components';

export const Health = (props) => {
  return <TenantComponents.Health {...props} />;
};

